import React, { useState } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/material";
import { IoClose } from "react-icons/io5";
import TextField from "@mui/material/TextField";
import './AddUser.css';
import { ColorButton } from "./AdminTable";
import axios from "axios";
import { baseURL } from "../Constant";
import { useSelector,useDispatch } from "react-redux";
import {add,setLoading} from "../Redux/TrackSlice";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 0,
            top: 0,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          {/* <CloseIcon /> */}
          <img
            src="images/Home/close_img.png"
            alt="icon"
            className="form_close_img"
          />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

function AddTrack(props) {
  const [newTrack, setNewTrack] = useState("");
  const [newLead, setNewLead]= useState("");
  const [isTrackNull, setIsTrackNull] = useState(false);  
  const [isLeadNull,setIsLeadNull]= useState(false);
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isDuplicateTrack, setIsDuplicateTrack] = useState(false);
  const [isTrackAddedSuccess, setIsTrackAddedSuccess] = useState(false);
  const dispatch= useDispatch();
  const {data,loading}= useSelector((state)=>state.track);

  const handleClose = () => {
    props.setOpenAdd(false);
    setNewTrack("");
    setIsAddOpen(false);
    setIsDuplicateTrack(false);
    setIsTrackAddedSuccess(false);
  };

  const saveAddHandle = async() => {
    if (newTrack == "") {
      setIsTrackNull(true);
    }

    else {
      if (data.some((item) => item.title === newTrack)) {
        setIsDuplicateTrack(true);
      } else {
        const newTrackObject= {
          title:newTrack,
          lead: newLead
        };
        try{
          
          const response= await axios.post(`${baseURL}/track-details`,newTrackObject,{
            headers: {
              'Content-Type': 'application/json',
            },
          });
            if(response.status===200){      
              dispatch(setLoading(true));        
              dispatch(add({id:response.data.newId,...newTrackObject,isActive:true}));
              setIsTrackNull(false);
              setIsLeadNull(false);
              setNewTrack("");
              setNewLead("");
              setIsTrackAddedSuccess(true);
            }
        }catch(err){
          console.log("error in adding track-->",err);
            alert("error in adding track");
        }        
      }
    }
  };

  let dialogHeaderStyle = {
    fontSize: "16px",
    fontWeight: "600",
    textAlign: "center",
    paddingBottom: "0px !important",
  }

  return (
    <BootstrapDialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={props.openAdd}>
      <BootstrapDialogTitle id="customized-dialog-title" className="popup" sx={dialogHeaderStyle}>
        <span className="add_user_heading">Add Track</span>
        <span onClick={handleClose} style={{ float: 'right', fontSize: '20px', cursor: 'pointer' }}><IoClose /></span>
      </BootstrapDialogTitle>
      {!isDuplicateTrack && !isTrackAddedSuccess ? (
        <DialogContent sx={{ paddingTop: "15px", width: "450px" }}>
          <Stack sx={{ padding: "5px 30px 10px 30px", marginTop: "10px" }} spacing={2}>
            <Stack spacing={1}>
              <Typography sx={{ fontSize: "14px", color: "#000000" }}>
                <span className="add_user_field_heading">Enter Track</span> <span style={{ color: "#A80011" }}>*</span>
              </Typography>
              <TextField
                error={isTrackNull && isAddOpen ? true : false}
                required={isTrackNull && isAddOpen ? false : true}
                className="coursecode-textfield"
                size="small"
                fullWidth
                multiline
                id={
                  isTrackNull && isAddOpen
                    ? "outlined-error"
                    : "outlined-required"
                }
                variant="outlined"
                helperText={
                  isTrackNull && isAddOpen
                    ? "Please enter the user name"
                    : null
                }
                onChange={(e) => {
                  setNewTrack(e.target.value);
                  if (newTrack !== "") {
                    setIsTrackNull(false);
                  }
                }}
                sx={{ width: "100%", fontSize: "14px !important" }}
                placeholder="Delivery Learning & Core schools, Security, Agile & DevOps, Delivery Leadership"
              />   
              <Typography sx={{ fontSize: "14px", color: "#000000" }}>
                <span className="add_user_field_heading">Enter Lead </span> <span style={{ color: "#A80011" }}>*</span>
              </Typography>      
               <TextField
                error={isLeadNull && isAddOpen ? true : false}
                required={isLeadNull && isAddOpen ? false : true}
                className="coursecode-textfield"
                size="small"
                fullWidth
                multiline
                id={
                  isTrackNull && isAddOpen
                    ? "outlined-error"
                    : "outlined-required"
                }
                variant="outlined"
                helperText={
                  isLeadNull && isAddOpen
                    ? "Please enter the user name"
                    : null
                }
                onChange={(e) => {
                  setNewLead(e.target.value);
                  if (newLead !== "") {
                    setIsLeadNull(false);
                  }
                }}
                sx={{ width: "100%", fontSize: "14px !important" }}
                placeholder="(ex: lakshay.c.gupta)"
              /> 

            </Stack>
          </Stack>

        </DialogContent>
      ) : isTrackAddedSuccess && !isDuplicateTrack ? (
        <DialogContent
          sx={{ paddingTop: "15px", paddingBottom: "15px", width: "450px" }}
        >
          <Stack
            sx={{ padding: "10px", marginTop: "10px" }}
            spacing={2}
          ></Stack>
          <Typography sx={{ fontSize: "14px", textAlign: "center" }}>
            Track Added Successfully!
          </Typography>
        </DialogContent>
      ) : (
        <DialogContent
          sx={{ paddingTop: "15px", paddingBottom: "15px", width: "450px" }}
        >
          <Stack
            sx={{ padding: "10px", marginTop: "10px" }}
            spacing={2}
          ></Stack>
          <Typography sx={{ fontSize: "14px", textAlign: "center" }}>
            The Track already exists!
          </Typography>
        </DialogContent>
      )}
      {!isDuplicateTrack && !isTrackAddedSuccess ? (
        <DialogActions
          sx={{
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <ColorButton
            variant="contained"
            className="save-button"
            size="small"
            sx={{
              "background-color": "white",
              "color": "black",
              "border": "1px solid blueviolet",
              "border-radius": "18px",
              "text-transform": "capitalize",
              "padding": "5px 20px",
              "font-weight": "600",
              "font-size": "14px"
            }}
            autoFocus
            onClick={saveAddHandle}
          >
            Submit
          </ColorButton>
          <ColorButton
            variant="contained"
            className="cancel-button"
            size="small"
            sx={{
              "background-color": "white",
              "color": "black",
              "border": "1px solid blueviolet",
              "border-radius": "18px",
              "text-transform": "capitalize",
              "padding": "5px 20px",
              "font-weight": "600",
              "font-size": "14px"
            }}
            autoFocus
            onClick={handleClose}
          >
            Cancel
          </ColorButton>
        </DialogActions>
      ) : (
        <DialogActions
          sx={{
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <ColorButton
            variant="contained"
            className="cancel-button"
            size="small"
            sx={{
              background: "white",
              color: "#7500C0",
              border: "solid 1px #7500C0",
            }}
            autoFocus
            onClick={handleClose}
          >
            Ok
          </ColorButton>
        </DialogActions>
      )}
    </BootstrapDialog>
  );
}

export default AddTrack;
